





























































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import SimpleMap from "@/components/SimpleMap.vue";

@Component({
  components: { SimpleMap },
})
export default class MainFooter extends Vue {
  [x: string]: any;
  goToGithub() {
    window.open("https://github.com/ToucanSoftware", "_blank");
  }
  goToLinkedIn() {
    window.open("https://www.linkedin.com/company/toucansoft", "_blank");
  }

  goToContactUs() {
    this.$router.push("/contact-us");
  }
}
